/**
 * Central config for the fbads.g1.network SPA.
 *
 * OIDC: public first-party client (`fbads-spa`) doing the authorization-code +
 * PKCE flow in-browser against auth.g1.network (same model as g1-ads
 * apps/spa). The exchanged access token (RS256 JWT) is sent as
 * `Authorization: Bearer <token>` to the same-origin /api/*, where the Worker
 * verifies it against g1-auth's JWKS. What the caller may then touch is decided
 * by this app's own tables, not by any claim in the token.
 */

/** Same-origin API (the Worker serves /api/* on this host). */
export const API_BASE = import.meta.env.VITE_API_BASE ?? "";

export const AUTH_ISSUER = import.meta.env.VITE_AUTH_ISSUER ?? "https://auth.g1.network";

export const OIDC_CLIENT_ID = import.meta.env.VITE_OIDC_CLIENT_ID ?? "fbads-spa";

/** Where auth.g1.network redirects back to after authorize. */
export const OIDC_REDIRECT_PATH = "/auth/callback";

export const OIDC_SCOPE = "openid profile email";

export const OIDC_AUTHORIZE_URL = `${AUTH_ISSUER}/oauth/authorize`;
export const OIDC_TOKEN_URL = `${AUTH_ISSUER}/oauth/token`;
